import {StyledText} from './DeleteText.styles'

const DeleteText = ({ text }) => (
  <StyledText>{text}</StyledText>
);

export default DeleteText;
